import { useEffect, useState } from "react";
import { api } from "./api";

export type SlugCheck =
  | { kind: "idle" }
  | { kind: "checking" }
  | { kind: "ok" }
  | { kind: "bad"; text: string }
  // Couldn't ask (offline, rate limited): don't block Save — the server
  // checks again when it's pressed.
  | { kind: "unknown" };

/** Asks the server, a beat after typing stops, whether `slug` can be this org's link. The rules
 *  live on the server; the page never second-guesses them. */
export function useSlugCheck(slug: string, current: string): SlugCheck {
  const [state, setState] = useState<SlugCheck>({ kind: "idle" });

  useEffect(() => {
    if (!slug || slug === current) {
      setState({ kind: "idle" });
      return;
    }
    setState({ kind: "checking" });
    let stale = false;
    const t = window.setTimeout(async () => {
      const res = await api.get<{ available: boolean; reason?: string }>(
        `/api/slug/check?slug=${encodeURIComponent(slug)}`,
      );
      if (stale) return;
      if (!res.ok) setState({ kind: "unknown" });
      else if (res.data.available) setState({ kind: "ok" });
      else setState({ kind: "bad", text: res.data.reason ?? "That link isn't available." });
    }, 400);
    return () => {
      stale = true;
      window.clearTimeout(t);
    };
  }, [slug, current]);

  return state;
}
